import { Capacitor } from '@capacitor/core';
import { isProductionEnvironment } from 'shared/envUtils';

export const getSSOCallbackOverrideUrl = (): string | undefined => {
  // web does not need to override the SSO callback URL
  if (!Capacitor.isNativePlatform()) {
    if (isProductionEnvironment()) {
      return undefined;
    }
    // in pre-production environment, override with currnt domain
    return `${window.location.origin}/sso/callback`;
  }

  // custom scheme for native apps
  return `watchduty://app.watchduty.org/sso/callback`;
};
